import {Link, useSearch} from '@tanstack/react-router';
import {capitalize} from 'es-toolkit';
import {useEffect, useState} from 'react';
import {toast} from 'sonner';
import {AuthForm, AuthPage, AuthPolicyFooter} from '@/features/auth';
import {sendEvent} from '@/libs/analytics';

export const AuthSignUpPage = () => {
  const {error, provider} = useSearch({from: '/_auth/auth/signup'});
  const [code] = useState(sessionStorage.getItem('inviteCode'));

  useEffect(() => {
    sendEvent('auth/visit');
  }, []);

  useEffect(() => {
    if (error) {
      toast.error(
        error === 'email_required' && provider
          ? `Для регистрации необходимо привязать email к учетной записи ${capitalize(provider)}.`
          : 'При регистрации произошла ошибка',
      );
    }
  }, [error, provider]);

  if (import.meta.env.VITE_ON_PREMISE_CLIENT_ID) {
    return (
      <AuthPage>
        <p className="text-center">
          Регистрация пользователей отключена, свяжитесь с администратором.
        </p>
      </AuthPage>
    );
  }

  return (
    <AuthPage footer={<AuthPolicyFooter />}>
      <h1 className="text-center text-title-h1">Попробуйте бесплатно</h1>

      {code ? (
        <div className="text-center text-paragraph-sm">
          Зарегистрируйтесь, чтобы присоединиться к команде
        </div>
      ) : (
        <div className="text-center text-paragraph-sm">
          Создавайте пошаговые инструкции для обучения работе с&nbsp;веб&#8209;сервисами и
          windows-приложениями
        </div>
      )}

      <AuthForm />

      <div className="w-full text-center text-paragraph-sm">
        Уже есть аккаунт?{' '}
        <Link className="text-brand-secondary" to="/auth/signin">
          Авторизуйтесь
        </Link>
      </div>
    </AuthPage>
  );
};
